import { useMutation, useQueryClient } from 'react-query';
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { USER_MESSAGE } from "../../../actions/User";
import axios from "axios";
import { useDispatch } from "react-redux";

const fetchNewPlateName = async ({ batch_id, type, item, selectedValue }) => {
    let apiUrl = "";
    switch (type) {
        case 'dyecal':
            switch (item) {
                case 'qc':
                    apiUrl = `${config.ENDPOINTS["datalake"]}/qc/dyecal_name/${batch_id}`;
                    break;
                case 'mfg':
                    apiUrl = `${config.ENDPOINTS["datalake"]}/mfg/dyecal_name/${batch_id}/${selectedValue}`;
                    break;
                default:
                    throw new Error(`Invalid item:${item}`);
            }
            break;
        case 'fluver':
            switch (item) {
                case 'qc':
                    apiUrl = `${config.ENDPOINTS["datalake"]}/qc/fluver_name/${batch_id}`;
                    break;
                case 'mfg':
                    apiUrl = `${config.ENDPOINTS["datalake"]}/mfg/fluver_name/${batch_id}/${selectedValue}`;
                    break;
                default:
                    throw new Error(`Invalid item:${item}`);
            }
            break;
        default:
            throw new Error(`Invalid type:${type}`);
    }
    const response = await axios.get(apiUrl,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};

const useFetchPlateName = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const mutation = useMutation(['fetchNewPlateNameMutation'], fetchNewPlateName, {
        onSuccess: (data) => {
            const { plate_name, batch_id } = data;
            queryClient.invalidateQueries("QCPlatelist");

            dispatch({
                type: USER_MESSAGE,
                msgType: "success",
                text: `${plate_name}  generated for Batch Name ${batch_id} and list refreshed`,
                key: crypto.randomUUID()
            });
        },
        onError: (error) => {
            queryClient.invalidateQueries("QCPlatelist");
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: "Generate Plate Name Failed",
                key: crypto.randomUUID()
            });
        },
    }
    );
    return mutation;
};

export default useFetchPlateName;

